import { render, staticRenderFns } from "./subsite.vue?vue&type=template&id=c8b4d112&scoped=true"
import script from "./subsite.vue?vue&type=script&lang=js"
export * from "./subsite.vue?vue&type=script&lang=js"
import style0 from "./subsite.vue?vue&type=style&index=0&id=c8b4d112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b4d112",
  null
  
)

export default component.exports